import star from "../../assets/star.svg";

const HeroBar = () => {
  return (
    <div className="border-y py-[2vw] flex justify-evenly overflow-hidden items-center gap-3 uppercase -rotate-2 border-gray-400">
      <p className="font-medium tracking-[0.3em] text-[3vw]">Jacket</p>
      <img loading="lazy" src={star} className="size-[4vw] rotate-2" />
      <p className="font-medium tracking-[0.3em] text-[3vw]">Jeans</p>

      <img loading="lazy" src={star} className="size-[4vw] rotate-2" />

      <p className="font-medium tracking-[0.3em] text-[3vw]">Shirts</p>

      <img loading="lazy" src={star} className="size-[4vw] rotate-2" />

      <p className="font-medium tracking-[0.3em] text-[3vw]">Shorts</p>
    </div>
  );
};

export default HeroBar;
